import { ONE_COLUMN_PAGE, ZONES, PAGE_CONTENT } from 'services/utility/constants'

export const convert = modules => modules.reduce((acc, module) => {
  const type = module.type
  if (type === ZONES.GUIDED_NAV) {
    acc[PAGE_CONTENT.SECONDARY_NAV] = [module]
  } else if (type === ZONES.META) {
    acc[PAGE_CONTENT.META_CONTENT] = module
  } else if (type === ZONES.RICH_TEXT_FOOTER) {
    acc[PAGE_CONTENT.FOOTER_CONTENT] = [module]
  } else {
    acc[PAGE_CONTENT.MAIN_CONTENT].push(module)
  }
  return acc
}, {
  secondaryNav: [],
  metaContent: {},
  mainContent: [],
  footerContent: [],
})

export const getPageDetails = () => {
  const { pathname } = window.location
  const page = pathname.split('/').filter(path => path !== '')
  const pageToBeFetched = ONE_COLUMN_PAGE
  const pageIdToBeFetched = page.length === 0 ? 'homePage' : page.join('/')
  return { pageToBeFetched, pageIdToBeFetched }
}

/**
 * Converts the tempo-runtime response into zone wise format.
 *
 * @param zoneA object in the array
 * @param zoneB object in the array
 * @returns 1 or -1 based on the zone value for sorting.
 */
export const compare = (
  { matchedTrigger: { zone: zoneA } },
  { matchedTrigger: { zone: zoneB } },
) => {
  if (Number.parseInt(zoneA.match(/\d+/), 10)
        < Number.parseInt(zoneB.match(/\d+/), 10)) {
    return -1
  }
  if (Number.parseInt(zoneA.match(/\d+/), 10)
        > Number.parseInt(zoneB.match(/\d+/), 10)) {
    return 1
  }
  return 0
}



// WEBPACK FOOTER //
// ./services/utility/cms/index.js